import React from "react";
import { Flex } from "@jsq/ds/core";
import { TabSection } from "../TabSection";
import { getControlTowerTabs } from "../TabSection/tabConfig";
import { ClientsTable } from "./ClientsTable";
import * as styles from "./styles_vanilla.css";

type ClientsViewProps = {
  showManagerTabs?: boolean;
  hasWorkflowAccess?: boolean;
};

export const ClientsView: React.FC<ClientsViewProps> = ({
  showManagerTabs = false,
  hasWorkflowAccess = false,
}) => {
  const tabs = getControlTowerTabs(showManagerTabs, hasWorkflowAccess);

  return (
    <Flex flexDirection="column" className={styles.container} data-testid="clients-view">
      <TabSection tabs={tabs} showManagerTabs={showManagerTabs} />
      <Flex flexDirection="column" className={styles.contentContainer}>
        <ClientsTable />
      </Flex>
    </Flex>
  );
};
